import { FC, useState } from 'react';
import { EPaymentMode, EPaymentStep } from '../StudentPaymentPane';
import { IPaymentAmountTableResult, IPaymentResult, IStudentPayment } from '../../../../models/payments.model';
import PaymentProcessingMain from './PaymentProcessingMain';
import { IParent, IStudent } from '../../../../models/students.model';
import { IPaymentAmount, ISelectedCoupon } from '../../../../models/studentStudent.model';

interface IProps {
  student?: IStudent;
  parent?: IParent;
  onSetPaymentMode: (mode: EPaymentMode) => void;
  paymentStep: EPaymentStep;
  setPaymentStep: (step: EPaymentStep) => void;
  studentPayments: IStudentPayment[];
  doGetStudentPayments: () => void;
  sendLog: (message: string, object?: object) => void;
}

const PaymentProcessing: FC<IProps> = ({
                                         student,
                                         parent,
                                         onSetPaymentMode,
                                         paymentStep,
                                         setPaymentStep,
                                         studentPayments,
                                         doGetStudentPayments,
                                         sendLog,
                                       }) => {
  const [paymentRecords, setPaymentRecords] = useState<IStudentPayment[]>([]);
  const [paymentAmounts, setPaymentAmounts] = useState<IPaymentAmount[]>([]);
  const [paymentResults, setPaymentResults] = useState<IPaymentResult[]>([]);
  const [amountTableResult, setAmountTableResult] = useState<IPaymentAmountTableResult>();
  const [selectedCoupons, setSelectedCoupons] = useState<ISelectedCoupon[]>([]);
  const [firstPaymentReceiptUrl, setFirstPaymentReceiptUrl] = useState<string>();
  const [secondPaymentReceiptUrl, setSecondPaymentReceiptUrl] = useState<string>();
  const [thirdPaymentReceiptUrl, setThirdPaymentReceiptUrl] = useState<string>();

  return (
    <>
      <PaymentProcessingMain
        student={student}
        parent={parent}
        onSetPaymentMode={onSetPaymentMode}
        paymentStep={paymentStep}
        setPaymentStep={setPaymentStep}
        studentPayments={studentPayments}
        paymentRecords={paymentRecords}
        setPaymentRecords={setPaymentRecords}
        paymentAmounts={paymentAmounts}
        setPaymentAmounts={setPaymentAmounts}
        paymentResults={paymentResults}
        setPaymentResults={setPaymentResults}
        amountTableResult={amountTableResult}
        setAmountTableResult={setAmountTableResult}
        selectedCoupons={selectedCoupons}
        setSelectedCoupons={setSelectedCoupons}
        firstPaymentReceiptUrl={firstPaymentReceiptUrl}
        setFirstPaymentReceiptUrl={setFirstPaymentReceiptUrl}
        secondPaymentReceiptUrl={secondPaymentReceiptUrl}
        setSecondPaymentReceiptUrl={setSecondPaymentReceiptUrl}
        thirdPaymentReceiptUrl={thirdPaymentReceiptUrl}
        setThirdPaymentReceiptUrl={setThirdPaymentReceiptUrl}
        doGetStudentPayments={doGetStudentPayments}
        sendLog={sendLog}
      />

    </>
  );
};

export default PaymentProcessing;